import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import * as Helpers from '../helpers';

const PrivateRouter = props => {
  const { component: Page } = props;
  return (
    <Route
      component={comProps => {
        const content = Helpers.token.get() ? (
          <Page {...props} {...comProps} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: comProps.location },
            }}
          />
        );
        return content;
      }}
    />
  );
};

export default PrivateRouter;
